(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/views/InfoTabsView',["jquery", "backbone", "commons/views/SlideView", "commons/views/EditorialScheduleView", "hbs!pricelist/templates/tabs", "hbs!pricelist/templates/discount", "hbs!pricelist/templates/addition", "hbs!pricelist/templates/supplement", "hbs!pricelist/templates/information", "hbs!pricelist/templates/booking", "hbs!pricelist/templates/technical"], function($, Backbone, SlideView, EditorialScheduleView, tabsTemplate, discountTemplate, additionTemplate, supplementTemplate, informationTemplate, bookingTemplate, technicalTemplate) {
    var $container, View, isFull, isPrint, mediaId, moduleMap;
    $container = $("#container");
    isFull = /proof/i.test(window.location.search);
    isPrint = $container.data("mediagroup") === "print";
    mediaId = $container.data("mediaid");
    moduleMap = $container.data("modulemap");
    return View = (function(superClass) {
      extend(View, superClass);

      function View() {
        this.render = bind(this.render, this);
        return View.__super__.constructor.apply(this, arguments);
      }

      View.prototype.el = "ul#controls";

      View.prototype.initialize = function() {
        this.template = tabsTemplate;

        /* Create the different lightbox views that the side bar should hold */
        this.discountLightbox = new SlideView({
          priceList: this.model,
          url: isPrint ? "/Advertising/Print/Discounts/" : "/Advertising/Digital/Discounts/",
          contentTemplate: discountTemplate,
          el: "#discount2"
        });
        this.additionLightbox = new SlideView({
          priceList: this.model,
          url: "/Advertising/Print/Additions/",
          contentTemplate: additionTemplate,
          el: "#addition"
        });
        this.supplementLightbox = new SlideView({
          priceList: this.model,
          url: "/Advertising/Print/Supplements/",
          contentTemplate: supplementTemplate,
          el: "#supplement"
        });

        /* NOT USED?
        @technicalLightbox = new SlideView
          id             : mediaId
          url            : "/Digital/PriceList/Technical/"
          contentTemplate: technicalTemplate
          el: "#technical"
         */
        if ((mediaId != null) && mediaId !== 0) {
          this.informationLightbox = new SlideView({
            id: mediaId,
            url: isPrint ? "/Advertising/Print/MediaTexts/" : "/Advertising/Digital/MediaTexts/",
            contentTemplate: informationTemplate,
            respWrapper: "information",
            el: "#information"
          });
        }

        /* NOT USED?
        if !isPrint
           * TODO: Correct this David.
          @bookingLightbox = new SlideView
            priceList      : @model # Change priceList to id if you want any other id than the pricelists.
            url            : "/??"
            contentTemplate: bookingTemplate
            el: "#booking"
         */
        return this.editorialscheduleLightbox = new EditorialScheduleView({
          el: "#editorialschedule"
        });
      };

      View.prototype.bindings = function() {
        return this.model.on("change:layout", this.render);
      };

      View.prototype.render = function() {
        var currentPriceList, id, label, priceLists;
        this.bindings();
        label = $("#select-priceList").find(":selected").data("label");
        if (label != null) {
          if (label.toLowerCase().indexOf("marathon") > -1) {
            $("#marathonLabel").show();
          } else {
            $("#marathonLabel").hide();
          }
        }
        priceLists = JSON.parse($("#PriceLists").val());
        id = this.model.get("id");
        currentPriceList = priceLists.find(function(x) {
          return x.Id.toString() === id;
        });

        /* CHECK WHICH TABS SHOULD BE SHOWN, WHEN BACKEND AVAILABLE
        
        id = @model.get "id"
        
        $.ajax
          url: "/Advertising/Tabs/" + id,
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        .done (res) ->
          alert()
         */
        this.$el.html(tabsTemplate({
          hasMediaId: (mediaId != null) && mediaId !== 0,
          isPrint: isPrint,
          moduleMap: moduleMap,
          tabs: currentPriceList.AdvertisingTabsRaw
        }));
        if (isFull) {
          this.showDiscounts();
          this.showAdditions();
          this.showSupplements();
          this.showEditorialschedule();
          this.showInformation();
          this.showTechnical();
        }
        return this;
      };

      View.prototype.events = {
        "click a[href=#discount2]": "showDiscounts",
        "click a[href=#addition]": "showAdditions",
        "click a[href=#supplement]": "showSupplements",
        "click a[href=#editorialschedule]": "showEditorialschedule",
        "click a[href=#information]": "showInformation"
      };

      View.prototype.sort = function() {
        this.model.layout(this.$("div:last input:checked").val());
        return app.router.navigate((this.model.get("id")) + "/" + this.model.get("layout"));
      };

      View.prototype.showDiscounts = function() {
        return this.discountLightbox.open();
      };

      View.prototype.showAdditions = function() {
        return this.additionLightbox.open();
      };

      View.prototype.showSupplements = function() {
        return this.supplementLightbox.open();
      };

      View.prototype.showEditorialschedule = function() {
        this.editorialscheduleLightbox.open();
        return this.editorialscheduleLightbox.show();
      };

      View.prototype.showInformation = function() {
        var ref;
        return (ref = this.informationLightbox) != null ? ref.open() : void 0;
      };

      View.prototype.showTechnical = function() {
        return this.technicalLightbox.open();
      };

      return View;

    })(Backbone.View);
  });

}).call(this);

//# sourceMappingURL=InfoTabsView.js.map
;
